import React from 'react';
import Icon from '../../../component/Icon';
import Inputbox from '../../../component/Inputbox';
const person =
  'https://thumbs.dreamstime.com/b/happy-person-portrait-smiling-woman-tanned-skin-curly-hair-happy-person-portrait-smiling-young-friendly-woman-197501184.jpg';
function Settings() {
  return (
    <div>
      <h2 className='text-3xl mb-4 text-greySecondary font-[500]'>
        Welcome Yashu Neupane
      </h2>

      {/* MAIN CONTAINER */}
      <div className='p-4 bg-white shadow-xl rounded-lg'>
        <div className='flex items-center gap-4'>
          <Icon name='edit' className='w-5 h-5' />
          <h2>Edit Profile</h2>
        </div>
        <div className='p-4 mb-4'>
          <h1 className='font-[500] text-lg'>Personal Information</h1>
          <p className='text-sm text-greySecondary'>
            Update your account’s profile and email address
          </p>
        </div>

        {/* CONTAINER */}
        <div className='flex mb-12 gap-16'>
          <div>
            <img
              src={person}
              alt='profile'
              className='block object-contain h-[12rem] rounded-xl'
            />
          </div>
          <div>
            <form>
              <div className='flex gap-2 mb-2 items-center justify-between'>
                <Inputbox
                  type='text'
                  name='firstname'
                  placeholder='John'
                  title='Firstname'
                />
                <Inputbox
                  type='text'
                  name='lastname'
                  placeholder='Doe'
                  title='Lastname'
                />
              </div>
              <div className='flex gap-2 mb-2 items-center justify-between'>
                <Inputbox
                  type='email'
                  name='email'
                  placeholder='john@gmail.com'
                  title='Email'
                />
                <Inputbox
                  type='number'
                  name='phone'
                  placeholder='9854784512'
                  title='Phone number'
                />
              </div>
              <button className='bg-darkPrimary ml-auto block w-[5rem] p-2 rounded-lg text-white font-[500] text-base'>
                Save
              </button>
            </form>
          </div>
        </div>

        {/* UPDATE PASSWORD */}
        <div className='flex gap-16'>
          <div>
            <h1 className='font-[500] text-lg'>Update Password</h1>
            <p className='text-sm text-greySecondary'>
              Secure your account using a strong password to stay secure.
            </p>
          </div>
          <div>
            <form>
              <div className='flex gap-2 mb-2 items-center justify-between'>
                <Inputbox
                  type='text'
                  name='firstname'
                  placeholder='********'
                  title='Current password'
                />
                <Inputbox
                  type='text'
                  name='lastname'
                  placeholder='********'
                  title='New Password'
                />
              </div>
              <div className='flex gap-2 mb-2 items-center justify-between'>
                <div className='flex-1'>
                  <Inputbox
                    type='text'
                    name='firstname'
                    placeholder='********'
                    title='Confirm New password'
                  />
                </div>

                <div className='flex-1 self-end'>
                  <button className='bg-darkPrimary ml-auto block w-[5rem] p-2 rounded-lg text-white font-[500] text-base'>
                    Save
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>

        {/* DONE AND CANCEL BUTTONS */}
        <div className='flex gap-2 text-white font-[600] justify-end mt-16 text-base'>
          <button className='bg-orange-400 p-2 w-[6rem] rounded-lg'>
            Done
          </button>
          <button className='bg-red-600 p-2 w-[6rem] rounded-lg'>Cancel</button>
        </div>
      </div>
    </div>
  );
}

export default Settings;
